var exports = {
  "n": "x9245d464--e6e2bd--link",
  "D": "x9245d464--e6e2bd--title",
};

module.exports = exports;
